import React, { memo, useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import {
  delete_icon,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import { useLocation, useNavigate } from "react-router-dom";
import { deletes, get, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import moment from "moment";
import { useGlobalContext } from "../../Services/PaginationGlobal";

const VideosList = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { paginationData, setpaginationData } = useGlobalContext();
  const path = pathname?.replace("/", "");
  const [active, setActive] = useState(
    paginationData?.[path]?.active ?? "User",
  );
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(false);
  const [pagination, setPagination] = useState(
    paginationData?.[path]?.pagination ?? {
      User: {},
      Hotels: {},
    },
  );
  const [list, setList] = useState({ User: [], Hotels: [] });

  const handleNavigation = (type, prob) => {
    navigate("/view-video", { state: { type: type, ...(prob ?? {}) } });
  };

  const addToGlobal = (d = {}) => {
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], ...d },
    }));
  };

  const columns = React.useMemo(() => {
    return [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <p className="red">
              {(pagination?.[active]?.current_page - 1) * 10 + (row.index + 1)}
            </p>
          );
        },
      },
      {
        Header: "Category",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "No: Videos",
        accessor: "no_of_videos",
        Cell: ({ value, row }) => {
          return (
            <p className="text-center">{String(value).padStart(2, 0)} Videos</p>
          );
        },
      },
      {
        Header: "No: Group Videos",
        accessor: "no_of_group_videos",
        Cell: ({ value, row }) => {
          return (
            <p className="text-center">{String(value).padStart(2, 0)} Videos</p>
          );
        },
      },
      {
        Header: "Uploaded Date",
        accessor: "updated_at",
        Cell: ({ value, row }) => {
          return <p>{moment(value).format("DD/MM/YYYY hh:mm A")}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  handleStatus(row.original);
                }}
                className={`${
                  value === 1 ? "active-btn" : "deactive-btn"
                } border-0 ms-2`}
                style={{ fontSize: "12px" }}
              >
                {value === 1 ? " Active" : "De-active"}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "id",
        Cell: ({ value, row }) => (
          <div className="d-flex ac-js">
            <button
              onClick={() =>
                handleNavigation("edit", {
                  category: row.original,
                  userType: active,
                })
              }
              className="cust-btn"
            >
              <img src={edit_icon} alt="" className="mx-2 edit-btn" />
            </button>

            <button
              onClick={() =>
                handleNavigation("view", {
                  category: row.original,
                  userType: active,
                })
              }
              className="cust-btn"
            >
              <img src={view_icon} alt="" className="mx-2 edit-btn" />
            </button>
            <button
              onClick={() =>
                setSelected({ type: "delete", data: row.original })
              }
              className="cust-btn "
            >
              <img src={delete_icon} alt="" className="edit-btn" />
            </button>
          </div>
        ),
      },
    ];
  }, [pagination?.[active]]);

  //api functions

  const getList = async (page = 1, search) => {
    let res = await get(
      `${URLS.VIDEOS_LIST}?type=${active === "User" ? 1 : 2}${search ? "&search=" + search : ""}`,
    );
    if (res?.status === "success") {
      if (search && res?.data?.length === 0) toast.info("No Records Found...");
      setList((prev) => ({ ...prev, [active]: res?.data }));
      addToGlobal({
        pagination: {
          ...[pagination],
          [active]: {
            current_page: page,
            last_page: res?.total_pages,
            count: res?.count,
          },
        },
        active: active,
      });
      setPagination((prev) => ({
        ...prev,
        [active]: {
          current_page: page,
          last_page: res?.total_pages,
          count: res?.count,
        },
      }));
    }
  };
  console.log("pagination", pagination?.[active]);
  useEffect(() => {
    getList();
  }, [active]);

  const handleStatus = async (d) => {
    let res = await put(`${URLS.VIDEOS_LIST_STATUS}${d.id}/`);
    if (res?.status === "success") {
      toast.success(res?.message);
      setList((prev) => ({
        ...prev,
        [active]: prev?.[active].map((item) =>
          item?.id === d?.id
            ? { ...item, status: d?.status === 1 ? 0 : 1 }
            : item,
        ),
      }));
    }
  };

  const handleDelete = async (data) => {
    let res = await deletes(URLS.VIDEOS_LIST_DELETE + data?.id + "/");
    if (res?.status === "success") {
      setList((prev) => ({
        ...prev,
        [active]: prev?.[active]?.filter((item) => item?.id != data?.id),
      }));
      toast.success(res?.message);
      setSelected(false);
    }
  };

  return (
    <div>
      <Topbar header={"Tutorial Videos"} back={true} />
      <div className="d-flex ac-jb">
        <div className="d-flex gap-3">
          {["User", "Hotels"].map((ele) => {
            return (
              <div
                key={ele}
                style={{
                  background: active == ele ? "#AE55F5" : "#78788029",
                  padding: "10px 30px",
                  borderRadius: 7,
                  cursor: "pointer",
                }}
                onClick={() => {
                  setSearch("");
                  setActive(ele);
                }}
              >
                <p style={{ color: active == ele ? "#fff" : "#000" }}>{ele}</p>
              </div>
            );
          })}
        </div>

        <div className="d-flex ac-js gap-3">
          <div className="search-input">
            <input
              onChange={(e) => {
                let val = e.target.value;
                setSearch(val);
                if (!val || val?.length >= 3) getList(1, val);
              }}
              value={search}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={Search_icon} className="search" />
          </div>
          <button
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white push-btn "
            onClick={() =>
              navigate("/add-video", {
                state: {
                  userType: { label: active, value: active === "User" ? 1 : 2 },
                },
              })
            }
          >
            + Tutorial Videos
          </button>
        </div>
      </div>
      <h2 className="f1 mt-3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22">
        Total No: {String(pagination?.[active]?.count ?? 0).padStart(2, 0)}
      </h2>

      <Table
        columns={columns}
        setPageno={(page) => {
          let pageCount = pagination?.[active] ?? {};
          if (pageCount?.current_page < pageCount?.last_page) getList(page);
        }}
        pagecount={pagination?.[active] ?? {}}
        data={list?.[active] ?? []}
        show={true}
      />

      {selected.type === "delete" && (
        <div className="img-popup-design">
          <div className="img-popup">
            {Boolean(Number(selected?.data?.no_of_videos) !== 0) && (
              <p className="text-danger mb-2 mt-2">
                This Category has mapped videos.
              </p>
            )}
            <p>Are you sure, want to Delete?</p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => handleDelete(selected?.data)}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => setSelected(false)}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};;

export default VideosList;
